import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fail",
  "use": "fail-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"fail\"><g fill-rule=\"evenodd\"><circle cx=\"8\" cy=\"8\" r=\"8\" /><g stroke=\"#FFF\" stroke-linecap=\"square\" stroke-width=\"1.5\"><path d=\"M5 5l6 6M11 5l-6 6\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id